var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductAtributeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 3.5,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 12.5,
    width: 7,
    height: 7,
    rx: 0.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20L18.3473 18.3443L20 20ZM19.2632 16.1316C19.2632 16.9621 18.9332 17.7587 18.3459 18.3459C17.7587 18.9332 16.9621 19.2632 16.1316 19.2632C15.301 19.2632 14.5045 18.9332 13.9172 18.3459C13.3299 17.7587 13 16.9621 13 16.1316C13 15.301 13.3299 14.5045 13.9172 13.9172C14.5045 13.3299 15.301 13 16.1316 13C16.9621 13 17.7587 13.3299 18.3459 13.9172C18.9332 14.5045 19.2632 15.301 19.2632 16.1316V16.1316Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAtributeSearch);
export default __webpack_public_path__ + "static/media/Product_Atribute _search.f5402a531792124a93c64bce8aadcd12.svg";
export { ForwardRef as ReactComponent };